
import IconUSMobile from '@core/icons/USMobile.svg'

import translations from './MobilePlans.translations'

export default {
  computed: {
    translations: () => translations,
    icon: () => IconUSMobile,
  },
}
